module.exports = __webpack_public_path__ + "fd051320d6bd1d78de5c70bf1cbb1932.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg59.jpeg
// module id = 71
// module chunks = 0